<small class="debug">{{me}}</small>
<div class="cart_properties">
  <div fxFlex fxLayoutAlign="space-between center">
    <mat-form-field style="flex: 1; margin-right: 10px;">
      <mat-label>{{'general.selectScene' | transloco}}</mat-label>
      <mat-select [(value)]="assignedScene" (selectionChange)="onSceneChange($event)">
        @for (scene of this.scenesSimple; track scene) {
          <mat-option [value]="scene">
            {{scene.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-icon-button class="mini-button" (click)="openSceneAssignmentDialog()" matTooltip="{{'general.assignScene' | transloco}}">
      <mat-icon>post_add</mat-icon>
    </button>
    <button mat-icon-button class="mini-button" (click)="openSceneEditor()" matTooltip="{{'general.editScene' | transloco}}">
      <mat-icon>photo_size_select_large</mat-icon>
    </button>
  </div>

  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <br/>
    </div>
  }
</div>
